import { render, staticRenderFns } from "./TransferenciaExpurgoOpmeConsignado.vue?vue&type=template&id=2d70fd0e&"
import script from "./TransferenciaExpurgoOpmeConsignado.vue?vue&type=script&lang=js&"
export * from "./TransferenciaExpurgoOpmeConsignado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports